module.exports = __webpack_public_path__ + "static/img/zt1.ed2b15bd.png";